import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_BACK_HOST,

  headers: {
    "Content-type": "application/json"
  }
});

console.log(process.env.REACT_APP_BACK_HOST)